module.exports = __webpack_public_path__ + "img/TREND_POINT.754b09f8.jpg";